import React, { memo, useCallback } from 'react';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// GLOBAL FUNCTIONS
import { documentFetch, fileDownload, makePath } from 'functions.js';

// MAIN COMPONENT
const ViewFileCell = ({ cell }) => {
  const { row } = cell;
  const { dsl_form_id, form_filename } = row?.original ?? {};

  const handleOnClick = useCallback(() => {
    if (!dsl_form_id) return;
    documentFetch({
      endpoint: makePath('admin/forms/downloadDSLForm/', dsl_form_id),
      loadingMessage: `Downloading ${form_filename}`,
      contentType: 'pdf',
      mimeType: 'application/pdf',
      onSuccess: ({ url }) => fileDownload(url, form_filename, null, null, true)
    })
  }, [dsl_form_id, form_filename]);

  // RENDER
  return <Button.Link onClick={handleOnClick} label={form_filename} />
}

export default memo(ViewFileCell);